import styled from 'styled-components';
import { Modal } from 'antd';

export const ModalContainer = styled(Modal)`
  .button-previous {
    margin: 0 8px;
  }

  .button-download {
    padding: 0;
  }

  .ant-steps {
    margin-bottom: 15px;
  }

  .action-activation,
  .action-validation,
  .action-network-reset {
    display: flex;
    flex-direction: column;
    justify-content: center;
    h5.ant-typography {
      display: flex;
      justify-content: center;
    }
  }

  .action-activation {
    .ant-row,
    .ant-select {
      width: 100%;
    }
  }

  .action-operator-restriction {
    .ant-select {
      width: 90%;
    }
  }

  .activation-upload-step-option,
  .activation-upload-step-description {
    color: ${({ theme }) => theme.colors.text1};
  }
`;
